/** @internal */

/** @internal */

/** @internal */
var BrickEvent;

/** @internal */
(function (BrickEvent) {
  BrickEvent["READ_SORTING_CHANGE"] = "read.sorting.change";
  BrickEvent["READ_SEARCH_CHANGE"] = "read.search.change";
  BrickEvent["READ_ADVANCED_SEARCH_CHANGE"] = "read.advancedSearch.change";
  BrickEvent["READ_PAGINATION_CHANGE"] = "read.pagination.change";
  BrickEvent["READ_SELECTION_CHANGE"] = "read.selection.change";
  BrickEvent["READ_RELATED_TO_ME_CHANGE"] = "read.relatedToMe.change";
  BrickEvent["READ_ALIVE_HOSTS_CHANGE"] = "read.alive.hosts.change";
  BrickEvent["READ_CATEGORY_CHANGE"] = "read.category.change";
  BrickEvent["READ_MULTIPLE_CLICK_ITEM"] = "read.multiple.clickItem";
  BrickEvent["READ_MULTIPLE_CREATE"] = "read.multiple.create";
  BrickEvent["CREATE_SINGLE_SUCCESS"] = "create.single.success";
  BrickEvent["CREATE_SINGLE_FAILED"] = "create.single.failed";
  BrickEvent["CREATE_SINGLE_CANCELED"] = "create.single.canceled";
  BrickEvent["CREATE_SINGLE_NEXT"] = "create.single.next";
  BrickEvent["CREATE_SINGLE_SELECT"] = "create.single.select";
  BrickEvent["UPDATE_SINGLE_SUCCESS"] = "update.single.success";
  BrickEvent["UPDATE_SINGLE_FAILED"] = "update.single.failed";
  BrickEvent["UPDATE_SINGLE_CANCELED"] = "update.single.canceled";
  BrickEvent["DELETE_SINGLE_SUCCESS"] = "delete.single.success";
  BrickEvent["DELETE_SINGLE_FAILED"] = "delete.single.failed";
  BrickEvent["DELETE_SINGLE_CANCELED"] = "delete.single.canceled";
  BrickEvent["CREATE_MULTI_SUCCESS"] = "create.multi.success";
  BrickEvent["CREATE_MULTI_FAILED"] = "create.multi.failed";
  BrickEvent["CREATE_MULTI_CANCELED"] = "create.multi.canceled";
  BrickEvent["DELETE_MULTI_SUCCESS"] = "delete.multi.success";
  BrickEvent["DELETE_MULTI_CANCELED"] = "delete.multi.canceled";
  BrickEvent["UPDATE_MULTI_SUCCESS"] = "update.multi.success";
  BrickEvent["UPDATE_MULTI_CANCELED"] = "update.multi.canceled";
  BrickEvent["UPDATE_MULTI_FAILED"] = "update.multi.failed";
  BrickEvent["UPDATE_SINGLE_SELECT"] = "update.single.select";
  BrickEvent["UPDATE_SINGLE_SELECTED"] = "update.single.selected";
  BrickEvent["READ_CARD_LEFT_BTN_CLICK"] = "read.card.leftBtn.click";
  BrickEvent["READ_CARD_RIGHT_BTN_CLICK"] = "read.card.rightBtn.click";
})(BrickEvent || (BrickEvent = {}));
/** @internal */
var PropertyDisplayType;

/** @internal */
(function (PropertyDisplayType) {
  PropertyDisplayType["Tag"] = "tag";
})(PropertyDisplayType || (PropertyDisplayType = {}));

/** @internal */

/** @internal */

/** @internal */

/**
 * 特性开关字典。
 *
 * @example
 *
 * ```json
 * {
 *   "next-builder-dynamic-menu": true
 * }
 * ```
 */

/**
 * 微应用基本信息。
 */

/**
 * 页面整体布局类型。
 */

/**
 * 应用的基本信息的本地化配置。
 *
 * @example
 *
 * ```yaml
 * zh:
 *   name: 搜索
 * en:
 *   name: Search
 * ```
 */

/**
 * 应用的单个地域的本地化配置。
 */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/**
 * 应用的 Storyboard 配置。
 */

/** @internal */

function isRouteConfOfBricks(conf) {
  return conf.type !== "routes" && !!conf.bricks;
}
function isRouteConfOfRoutes(conf) {
  return conf.type === "routes";
}

/**
 * 路由配置，类型可以是构件列表、子路由列表和重定向中的一种。
 */

export { BrickEvent, PropertyDisplayType, isRouteConfOfBricks, isRouteConfOfRoutes };
//# sourceMappingURL=index.esm.js.map
